// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"e838c9a4","204":"4305a5b5","412":"563f6c29","438":"9a234228","623":"dd235c21","707":"d0b402de","814":"ad98b14c","820":"e9268408","875":"e78a4499"}[chunkId] + ".chunk.js";
};